<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1554GzK/tc-custom/9781504010344.jpg?1697124105684" alt="This image is the cover for the book Enemies of the System"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Enemies of the System
      </h1>
      <p class="bookDescription body article font2">
        <b>In the far future, a group of evolved utopians stranded on an inhospitable planet are unable to resist the reemergence of the human animal</b><br/><br/> One million years in the future, the universe has become a utopia for the humans inhabiting it. Having evolved into the race <i>homo uniformis</i>—“man alike throughout”—they share a centralized nervous system and know nothing of war, disease, violence, emotion, or any of the ancient ills that plagued their ancestors. But while en route to a vacation that is light years from Earth, a small group of elite travelers find themselves marooned in the wilderness of the planet Lysenka. And they are not alone. Many millennia ago, during Earth’s darker days, human colonists came to this regenerate world, and the creatures their descendants became out of necessity bear little resemblance to the uniquely civilized beings now stranded in their midst. Here, in this place far removed from the protection of uniformity, there is only one rule: Adapt—or die.<br/>  <br/> One of the twentieth century’s premier practitioners of the art of science fiction, Grand Master Brian W. Aldiss offers readers a startling look into the far future with a remarkable work of speculation that explores what it means to be human.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian W. Aldiss
      </h2>
      
      <p class="authorDescription body article">Brian W. Aldiss was born in Norfolk, England, in 1925. Over a long and distinguished writing career, he published award‑winning science fiction (two Hugo Awards, a Nebula Award, and the John W. Campbell Memorial Award); bestselling popular fiction, including the three‑volume Horatio Stubbs saga and the four‑volume the Squire Quartet; experimental fiction such as <I>Report on Probability A</I> and <I>Barefoot in the Head</I>; and many other iconic and pioneering works, including the Helliconia Trilogy. He edited many successful anthologies and published groundbreaking nonfiction, including a magisterial history of science fiction (<I>Billion Year Spree</I>, later revised and expanded as <I>Trillion Year Spree</I>). Among his many short stories, perhaps the most famous was &ldquo;Super‑Toys Last All Summer Long,&rdquo; which was adapted for film by Stanley Kubrick and produced and directed after Kubrick&rsquo;s death by Steven Spielberg as <I>A.I. Artificial Intelligence</I>.&#160;Brian W. Aldiss passed away in 2017 at the age of 92.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2787535e